module.exports = __webpack_public_path__ + "img/icon_tourism_shop.39a1e445.png";